import { __rest } from "tslib";
import React from 'react';
import { Box, Flex } from '@marvelapp/ui';
import { Heading } from './Heading';
import { Text } from './Text';
/**
 * @deprecated Use
 * ```
 * import { BtwSettingsItem } from '@marvelapp/ballpark-components'
 * ```
 * instead
 */
export function SettingsItem(_a) {
    var { children, description, extraInfo, flexDirection, headingSize = 'm', maxWidth = 500, title } = _a, props = __rest(_a, ["children", "description", "extraInfo", "flexDirection", "headingSize", "maxWidth", "title"]);
    return (React.createElement(Box, Object.assign({ borderBottom: "1px solid", borderColor: "slate6", paddingY: "m" }, props),
        React.createElement(Flex, { flexDirection: flexDirection },
            React.createElement(Box, { flex: 1, paddingRight: "s", paddingY: "xs" },
                React.createElement(Heading, { alignItems: "center", display: "flex", fontSize: headingSize, fontWeight: "medium", htmlFor: 1, lineHeight: 1.3, tag: "label" }, title),
                React.createElement(Text, { color: "slate11", fontSize: "s", maxWidth: maxWidth, mt: "xs" }, description)),
            React.createElement(Flex, { alignItems: "center", flexDirection: flexDirection }, children)),
        extraInfo));
}
